export const applicationSubscriptionStorageKey = "ApplicationSubscriptionId";
export const organisationStorageKey = "OrganisationId";
export const lmsUrlStorageKey = "lms-mobile-lms-url";
export const workspaceUserStorageKey = "lms-mobile-workspace-user-id";
export const branchStorageKey = "lms-preprod-mobile-branch";
export const branchLoadingStorageKey = "lms-mobile-loading-branch";
export const branchLoadingLatestReleaseStorageKey =
    "lms-mobile-loading-latest-release";
export const currentLmsVersionStorageKey = "CURRENT_LMS_VERSION";
export const mobileUiInWrapperStorageKey =
    "lms-mobile-use-mobile-ui-in-wrapper";
export const mobileUiInNativeWrapperStorageKey =
    "lms-mobile-use-mobile-ui-in-native-wrapper";
